/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import Transformer from '@/transformers/AccountTransformer';
import Proxy from '@/proxies/user/AccountProxy';
import { USER_FETCHED } from '@/store/modules/auth/mutation-types';
import { errorFunc } from '@/utils/errorFunc';
import * as types from './mutation-types';

export const find = ({ commit }) => {
  /*
   * Normally you would use a proxy to fetch the account:
   *
   * new Proxy()
   *  .find()
   *  .then((response) => {
   *    commit(types.FIND, Transformer.fetch(response));
   *  })
   *  .catch(() => {
   *    console.log('Request failed...');
   *  });
   */
  const account = {
    first_name: 'John',
    last_name: 'Doe',
    email: 'jonh@doe.com',
  };

  commit(types.FIND, Transformer.fetch(account));
};

// eslint-disable-next-line
export const fetchUser = ({ commit }, payload) => {
  return new Proxy()
    .update('user', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, response.user, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};


// eslint-disable-next-line
export const changeActionNotification = ({ commit }, payload) => {
  return new Proxy()
    .update('action-notification', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { action_notification: response.action_notification }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeWarehousePriorityFreeze = ({ commit }, payload) => {
  return new Proxy()
    .update('warehouse-priority-freeze', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { warehouse_priority_freeze: response.warehouse_priority_freeze }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeInquiryNotification = ({ commit }, payload) => {
  return new Proxy()
    .update('inquiry-notification', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { is_inquiry_notification_enabled: response.is_inquiry_notification_enabled }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeBccSync = ({ commit }, payload) => {
  return new Proxy()
    .update('bcc_sync', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { bcc_sync: response.bcc_sync }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeInitialSync = ({ commit }, payload) => {
  return new Proxy()
    .update('initial_sync', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { initial_sync: response.initial_sync }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeSyncActionsToTasks = ({ commit }, payload) => {
  return new Proxy()
    .update('sync_actions_to_tasks', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { sync_actions_to_tasks: response.sync_actions_to_tasks }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

// eslint-disable-next-line
export const changeSyncActionsToMsTodo = ({ commit }, payload) => {
  return new Proxy()
    .update('sync_actions_to_ms_todo', payload)
    .then((response) => {
      commit(`auth/${USER_FETCHED}`, { sync_actions_to_ms_todo: response.sync_actions_to_ms_todo }, { root: true });
    })
    .catch(response => errorFunc(response, commit));
};

export default {
  find,
  changeActionNotification,
  changeBccSync,
  changeInitialSync,
  changeSyncActionsToTasks,
  changeSyncActionsToMsTodo,
  changeInquiryNotification,
  changeWarehousePriorityFreeze,
  fetchUser,
};



// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js